import React, { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "@react-native-firebase/database";
import { View, Text, TouchableOpacity, Dimensions } from "react-native";
import Menu from "../Menu";
import DropDownField from "src/components/DropDownField";
import Loader from "src/components/Loader";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import StyleSheetRW from "core/StyleSheetRW";
import auth from "@react-native-firebase/auth";
import { isAdminUser } from "src/utils/UserUtils";
import navhelper from "core/navhelper";
import { BsEyeFill } from "react-icons/bs";
import { BiSolidReport } from "react-icons/bi";
import projectIcon from "res/img/projectIcon.png";
import { TextInput } from "react-native";
import { getLocalStorageItem } from "core/helpers";
const YearOptions = ["Last 1 Year", "Last 2 Years", "Last 5 Years"];

const getYearRangeValue = (yearString) => {
    const match = yearString.match(/\d+/);
    return match ? parseInt(match[0]) : null;
};

const AdminReviewsScreen = () => {
    const [changeRole, setChangeRole] = useState("");
    const [selectedYearRange, setSelectedYearRange] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [reviewSubmitted, setReviewSubmitted] = useState([]);
    const [filteredRatings, setFilteredRatings] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userType, setUserType] = useState("");
   const [loggedinUser,setLoggedinUser]=useState(null)

    useEffect(() => {
        auth()
            .getCurrentUser()
            .then((user) => {
               setLoggedinUser(user)
                if (isAdminUser(user)) {
                    setUserType("Admin");
                } else {
                    setUserType("Normal");
                }
            })
            .catch((error) => {
                console.error("Error getting current user:", error);
            });
    }, []);

    useEffect(() => {
        setShowLoader(true);
        const dbRef = ref(db, "userRoles");
        const unsubscribe = onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const rolesList = Object.keys(data).map((key) => data[key]);
                setRoles(rolesList);
                setShowLoader(false);
            } else {
                console.log("No data available");
                setShowLoader(false);
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        setShowLoader(true);
        const dbRef = ref(db, 'reviewAssignment');
        const fetchRequestUpdatedData = onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();

                const parsedRatings = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setReviewSubmitted(parsedRatings);
                setFilteredRatings(parsedRatings);
                setShowLoader(false);
            } else {
                setShowLoader(false);
                console.log("No data available");
            }
        }, (error) => {
            setShowLoader(false);
            console.error("Failed to retrieve data:", error);
        });

        return () => fetchRequestUpdatedData();
    }, []);

    const handleApplyFilter = () => {
        let filtered = reviewSubmitted;

        if (changeRole || selectedYearRange || searchQuery) {
            filtered = filtered.filter(rating => {
                let match = true;
    
                if (searchQuery) {
                    const query = searchQuery.toLowerCase();
                    match = rating.ReviewedUserName.toLowerCase().includes(query);
                }
    
                if (match && changeRole && rating.ReviewerRole !== changeRole) {
                    match = false;
                }
    
                if (match && selectedYearRange) {
                    const yearRange = getYearRangeValue(selectedYearRange);
                    if (yearRange !== null) {
                        const currentYear = new Date().getFullYear();
                        if ((currentYear - parseInt(rating.year)) > yearRange) {
                            match = false;
                        }
                    }
                }
    
                return match;
            });
        }
    
        setFilteredRatings(filtered);
    };

    const handleClearFilter = () => {
        setChangeRole("");
        setSelectedYearRange("");
        setSearchQuery("");
        setFilteredRatings(reviewSubmitted);
    };
    
    const getRoleInfo = (role) => {
        const roleRatings = reviewSubmitted.filter(rating => rating.ReviewerRole === role);
        const count = roleRatings.length;
        const dueDates = roleRatings.map(rating => rating.dueDate);
        const pending = roleRatings.filter(rating => rating.status === "In-Process"||rating.status === "Saved").length;
        const completed = roleRatings.filter(rating => rating.status === "Submitted").length;

        return {
            role,
            count: count || "0",
            dueDates,
            pending: pending || "0",
            completed: completed || "0",
            earliestDueDate: dueDates.length ? dueDates.sort((a, b) => new Date(a) - new Date(b))[0] : "0",
        };
    };

    const screenWidth = Dimensions.get("window").width;

    return (
        <div style={styles.mainContainer}>
            <Menu />
            {showLoader && <Loader />}
            <div style={styles.container}>
                <div style={styles.heading}>Review Dashboard</div>
                <View style={{ ...styles.inputRow, justifyContent: userType === "Normal" ? "flex-start" : "space-between" }}>
                    {userType === "Admin" && <View style={styles.inputContainer}>
                        <Text style={{ ...styles.label, marginTop: 5 }}>Please select a UserRole</Text>
                        <DropDownField
                            value={changeRole}
                            placeholder="Please Select a Role"
                            placeholderTextColor={"rgb(109,126,124)"}
                            bodyStyle={{ marginHorizontal: 0 }}
                            options={roles}
                            onChangeText={(text)=> setChangeRole(text)}
                            label="Role"
                        />
                    </View>
                    }
                    

                        <View style={styles.inputContainer}>
                            <Text style={{ ...styles.label, marginTop: 5 }}>Search by name</Text>
                            <TextInput
                                style={{ ...styles.textInput }}
                                placeholder="Search by name"
                                placeholderTextColor={"rgb(109,126,124)"}
                                value={searchQuery}
                                onChangeText={text => setSearchQuery(text)}
                            />
                        </View>

                    <View style={styles.inputContainer}>
                        <Text style={{ ...styles.label, marginTop: 5 }}>Please select a Year Range</Text>
                        <DropDownField
                            value={selectedYearRange}
                            placeholder="Please Select a Year Range"
                            placeholderTextColor={"rgb(109,126,124)"}
                            bodyStyle={{ marginHorizontal: 0 }}
                            options={YearOptions}
                            onChangeText={setSelectedYearRange}
                            label="Year Range"
                        />
                    </View>
                    {userType === "Normal" && 
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <TouchableOpacity
                        style={{ ...styles.addButton, marginLeft: 20, marginTop: 25 }}
                        onPress={handleApplyFilter}
                    >
                        <Text style={styles.addCandidateButtonText}>Apply</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={{ ...styles.clearButton, marginLeft: 20, marginTop: 25 }}
                        onPress={handleClearFilter}
                    >
                        <Text style={styles.addCandidateButtonText}>Clear Filter</Text>
                    </TouchableOpacity>
                    </div>}
                </View>
                {userType === "Admin" && <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TouchableOpacity
                        style={{ ...styles.addButton, marginLeft: 5 }}
                        onPress={handleApplyFilter}
                    >
                        <Text style={styles.addCandidateButtonText}>Apply</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={{ ...styles.clearButton, marginLeft: 20 }}
                        onPress={handleClearFilter}
                    >
                        <Text style={styles.addCandidateButtonText}>Clear Filter</Text>
                    </TouchableOpacity>
                </div>}
                <div style={styles.cardContainer}>
                    {roles.map((role, index) => {
                        const roleInfo = getRoleInfo(role);
                        return (
                            <div key={index} style={{ ...styles.roleCard, flex: "1 0 30%" }}>
                                <div style={styles.cardStyle1}>
                                    <div style={{ marginBottom: 20 }}>
                                        <strong>Role:</strong> {roleInfo.role}
                                    </div>
                                    <div style={{ marginBottom: 20 }}>
                                        <strong>Count:</strong> {roleInfo.count}
                                    </div>
                                </div>
                                <div style={styles.cardStyle1}>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <strong>Due Date:</strong> {roleInfo.earliestDueDate}
                                    </div>
                                    <div style={styles.cardStyle2}>
                                        <strong>Pending:</strong> {roleInfo.pending}
                                    </div>
                                    <div style={styles.cardStyle2}>
                                        <strong>Completed:</strong> {roleInfo.completed}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div style={styles.tableMainContainer}>
                    <h3>Aggregated Ratings and Comments</h3>
                    <table style={styles.table}>
                        <thead style={styles.tableHead}>
                            <tr style={styles.tableHeadRow}>
                                <th style={styles.tableHeadItem}>Name</th>
                                <th style={styles.tableHeadItem}>Role</th>
                                {userType === "Admin" && <th style={{ ...styles.tableHeadItem, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell"}}>Reviewer</th>}
                                <th style={{ ...styles.tableHeadItem, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>Status</th>
                                <th style={{ ...styles.tableHeadItem, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>Start-Date</th>
                                <th style={{ ...styles.tableHeadItem, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>Due-Date</th>
                                <th style={styles.tableHeadItem}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {filteredRatings.map((reviewSubmittedData, index) => (
                            
    ( (userType==='Normal'&&loggedinUser.uid===reviewSubmittedData.ReviewerUserID)||(userType==='Admin'&&reviewSubmittedData.status!=='Saved'))&&(
        <tr key={index}>
            <td style={styles.tableData}>{reviewSubmittedData.ReviewedUserName}</td>
            <td style={styles.tableData}>{reviewSubmittedData.ReviewerRole}</td>
            {userType === "Admin" && <td style={{ ...styles.tableData, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell"}}>{reviewSubmittedData.ReviewerUserName}</td>}
            <td style={{ ...styles.tableData, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>{reviewSubmittedData.status}</td>
            <td style={{ ...styles.tableData, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>{reviewSubmittedData.startDate}</td>
            <td style={{ ...styles.tableData, display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "table-cell" }}>{reviewSubmittedData.dueDate}</td>
            
            {/* Admin view */}
            {userType === "Admin" && (
                <td style={styles.simpletabelData}>
                    {reviewSubmittedData.status === 'Submitted' && (
                        <div style={styles.endBar}>
                            <BsEyeFill
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    navhelper.push('ReviewSubmissionScreen', { review: reviewSubmittedData, mode: 'View' });
                                }}
                            />
                            <img
                                src={projectIcon}
                                alt="Summary"
                                style={{ height: 18, width: 18,cursor:"pointer" }}
                                // onClick={()=>{
                                //     navhelper.push(`SubmittedReviewScreen?reviewedUserName=${reviewSubmittedData.ReviewedUserName}`)
                                // }}
                            />
                        </div>
                    )}
                </td>
            )}
            {userType === "Normal" && reviewSubmittedData.status !== 'Submitted' && (
                <td style={styles.simpletabelData}>
                    <button
                        style={{ ...styles.addButton, width: "100px" }}
                        onClick={() => navhelper.push('ReviewSubmissionScreen', { review: reviewSubmittedData, mode: 'Edit' })}
                    >
                        Start
                    </button>
                </td>
            )}
        </tr>
    )
))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const styles = StyleSheetRW.create(() => ({
    tableMainContainer: { overflow: "scroll", marginTop: 20, scrollbarWidth: 'none' },
    mainContainer: { display: "flex", flexDirection: "row", height: "100%" },
    container: { flex: 1, padding: 20, overflow: "scroll", scrollbarWidth: 'none' },
    table: {
        borderCollapse: "collapse",
        backgroundColor: "#FFFFFF66",
        width: "100%",
        overflow: "hidden",
    },
    tableData: { borderRight: "1px solid black", padding: "15px" },
    simpletabelData : {padding: "15px"},
    tableHeadItem: { padding: "15px" },
    tableHeadRow: { backgroundColor: "#2F4858", color: "#FFFFFF", textAlign: "left" },
    tableHead: { fontSize: 14 },
    cardContainer: { display: "flex", flexWrap: "wrap", gap: "20px", marginTop: 20 },
    cardStyle1: { display: "flex", flexDirection: "row", justifyContent: "space-between" },
    cardStyle2: { display: "flex", flexDirection: "column", alignItems: "center" },
    heading: {
        fontWeight: "700",
        marginTop: 5,
        fontSize: 36,
        color: "#2F4858",
    },
    addButton: {
        width: 147,
        backgroundColor: "#2F4858",
        paddingVertical: 10,
        paddingHorizontal: 20,
        borderRadius: 100,
        color: "white",
        fontWeight: "300",
        textAlign: "center",
        borderWidth: 0,
        alignSelf: "center",
        height: "38px",
        cursor: "pointer",
        marginTop: 10
    },
    inputRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    endBar: { height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' },
    inputContainer: {
        flex: 1,
        margin: 5,
        minWidth: "300px",
    },
    textInput: {
        fontFamily: "Outfit",
        borderTopRightRadius: 10,
        height: 50,
        outline: "none",
        borderRadius: 10,
        paddingLeft: 15,
        marginTop: 3,
        borderStyle: "none",
        backgroundColor: "#0000000D",
    },
    label: {
        fontFamily: "Outfit",
        fontSize: 14,
        fontWeight: "600",
        lineHeight: 17.64,
        textAlign: "left",
        marginBottom: 5,
        color: "#333333",
    },
    addCandidateButtonText: {
        color: "white",
        fontWeight: "400",
        textAlign: "center",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: 20,
    },
    tableHeader: {
        backgroundColor: "#f2f2f2",
    },
    tableCell: {
        border: "1px solid #ccc",
        padding: 8,
        textAlign: "left",
    },
    roleCard: {
        backgroundColor: "#2F4858",
        padding: "10px 20px",
        borderRadius: 10,
        color: "white",
        marginBottom: 5,
        width: "100%",
        maxWidth: "calc(100% - 20px)",
        boxSizing: "border-box",
    },
    clearButton: {
        width: 147,
        backgroundColor: "#2F4858",
        paddingVertical: 10,
        paddingHorizontal: 20,
        borderRadius: 100,
        color: "white",
        fontWeight: "300",
        textAlign: "center",
        borderWidth: 0,
        alignSelf: "center",
        height: "38px",
        cursor: "pointer",
        marginTop: 10
    },
}));

export default AdminReviewsScreen;
